import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, pricing } from '../data/landing';
type PriceCardProps = {
  subtitle: string;
  idealFor?: string;
  ctaLabel: string;
  currentPrice?: string;
  title?: string;
  originalPrice?: string;
  badge?: string;
};
export function PriceCard({
  subtitle,
  idealFor,
  ctaLabel,
  currentPrice = pricing.current,
  title = 'MegaPack Colon Tranquilo',
  originalPrice = pricing.original,
  badge = 'Precio de lanzamiento'
}: PriceCardProps) {
  return <div className="relative mx-auto w-full max-w-2xl rounded-[2rem] border-2 border-brand bg-white p-7 text-center shadow-[0_24px_60px_-30px_rgba(20,83,45,0.45)] md:p-10" data-id="element-29" data-mp="31fdc5rg4jbim">
      <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand px-4 py-1.5 text-xs font-black uppercase tracking-wider text-white" data-id="element-30" data-mp="2rgxhxflsvm4w">
        {badge}
      </span>
      <BookOpenIcon className="mx-auto h-9 w-9 text-brand" aria-hidden="true" data-id="element-31" data-mp="1g3leh5tyd5j9" />
      <h3 className="mt-3 text-2xl font-black uppercase leading-tight text-brand md:text-3xl" data-id="element-32" data-mp="3klb1wi7nqizw">
        {title}
      </h3>
      <p className="mt-2 text-base font-semibold text-charcoal md:text-lg" data-id="element-33" data-mp="3fob3mth1ukjc">{subtitle}</p>
      {idealFor && <p className="mt-3 text-sm text-muted" data-id="element-34" data-mp="3to2fank3fou6">
          <span className="font-bold text-charcoal" data-id="element-35" data-mp="3on6ckdbha8qc">Ideal para:</span> {idealFor}
        </p>}
      <div className="mt-6 flex flex-col items-center" data-id="element-36" data-mp="7f16eetuxdud">
        <span className="text-xl font-semibold text-muted line-through decoration-danger decoration-2" data-id="element-37" data-mp="7dpzw7911rzk">
          {originalPrice}
        </span>
        <span className="mt-2 flex items-baseline gap-2 rounded-2xl bg-gold-soft px-5 py-2" style={{
        minWidth: "284px",
        height: "63px"
      }} data-id="element-38" data-mp="g8e5xzmffdpf">
          <span className="whitespace-nowrap text-6xl font-black tracking-tight text-brand md:text-7xl" style={{
          fontSize: "48px"
        }} data-id="element-39" data-mp="c6sy4sor1pm3">
            {currentPrice}
          </span>
          <span className="text-lg font-bold text-charcoal" data-id="element-40" data-mp="l8aca5iljh85">{pricing.currency}</span>
        </span>
      </div>
      <div className="mt-7 flex justify-center" data-id="element-41" data-mp="3f0ieqfon130x">
        <CtaButton href={checkoutUrl} data-id="element-42" data-mp="3j09br14rcfdw">{ctaLabel}</CtaButton>
      </div>
    </div>;
}